import { render } from "./KamranGallery.vue?vue&type=template&id=4e675820&scoped=true"
import script from "./KamranGallery.vue?vue&type=script&lang=js"
export * from "./KamranGallery.vue?vue&type=script&lang=js"

import "./KamranGallery.vue?vue&type=style&index=0&id=4e675820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e675820"]])

export default __exports__